import * as React from "react";
import {ISvgIconProps, SvgIcon} from '../../../basic-ui-components/icon/svg-icon/svg.icon';

export class MobileMenuNoSearchIcon extends React.Component<ISvgIconProps, {}> {
    render() {
        return <SvgIcon {...this.props} viewBox="0 0 26 18" ratio={26/18}>
            <g>
                <path d="M19.4252 0H1.5748C0.705063 0 0 0.710972 0 1.588C0 2.46503 0.705063 3.176 1.5748 3.176H19.4252C20.2949 3.176 21 2.46503 21 1.588C21 0.710972 20.2949 0 19.4252 0Z" fill="currentColor"/>
                <path d="M19.4252 7.412H1.5748C0.705063 7.412 0 8.12297 0 9C0 9.87703 0.705063 10.588 1.5748 10.588H19.4252C20.2949 10.588 21 9.87703 21 9C21 8.12297 20.2949 7.412 19.4252 7.412Z" fill="currentColor"/>
                <path d="M19.4252 14.824H1.5748C0.705063 14.824 0 15.535 0 16.412C0 17.289 0.705063 18 1.5748 18H19.4252C20.2949 18 21 17.289 21 16.412C21 15.535 20.2949 14.824 19.4252 14.824Z" fill="currentColor"/>
            </g>
        </SvgIcon>;
    }
}
